import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./load.module.css";
// import Table from 'react-bootstrap/Table';
// import LoadDetailsCard from "../../../components/LoadDeatilsCard";

import { showConfirmDialog } from "../../../helpers/helper";
// import RouteMap from "../../../components/loadMap";
// import { MdOutlineRefresh } from "react-icons/md";
import { post } from "../../../components/api";

const Load = () => {
  const { state } = useLocation();

  const [bid, setBid] = useState([
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
    // { data: 1, key: 1 },
  ]);
  const fetchBids = async () => {
    const response = await post(`company/ltms/get/bid/${state._id}`, {});
    if (response.data.status === 200) {
      setBid(response.data.data);
    }
  };

  useEffect(() => {
    fetchBids();
  }, []);

  const handleClick = async (id) => {
    const confirmed = await showConfirmDialog(
      "Accept!",
      "Are you sure you want to Accept This Bid?"
    );
    if (confirmed) {
      try {
        const response = await post(`company/ltms/bid-accept/${id}`, {});
        if (response.status === 200) {
          state.status = "Accepted";
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const extractAddressComponents = (address) => {
    const parts = address.split(",").map((part) => part.trim()); // Split by comma and trim spaces
    const length = parts.length;

    if (length < 3) {
      return { city: "", state: "", pincode: "", country: "" }; // Handle incorrect format
    }

    const country = parts[length - 1]; // Last part is Country
    const statePincode = parts[length - 2].split(" "); // Second last part contains State & Pincode
    const state = statePincode.slice(0, -1).join(" "); // All except last word is State
    const pincode = statePincode[statePincode.length - 1]; // Last word is Pincode
    const city = parts[length - 3]; // Third last part is City

    return { city, state, pincode, country };
  };

  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "start",
          fontSize: "28px",
          fontWeight: "500",
          color: "rgba(68, 88, 95, 1)",
          padding: "10px 0px 20px 10px",
        }}
      >
        <p className="mb-0">Load</p>
      </div>
      <div className={`row gx-4 gy-4 ${styles.Info}`}>
        <div className={`col-md-4 col-lg-4 col-xs-12`}>
          <div className={styles.load_card_body}>
            <div className={styles.loadFirst}>
              <div>
                <svg
                  width="10"
                  height="144"
                  viewBox="0 0 10 124"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginTop: "0px" }}
                >
                  <circle
                    cx="4.57291"
                    cy="4.57291"
                    r="4.57291"
                    fill="#E57556"
                    fillOpacity="0.5"
                  />
                  <circle
                    cx="4.57299"
                    cy="4.57292"
                    r="3.42968"
                    fill="#E57556"
                  />
                  <circle
                    cx="4.57291"
                    cy="106.573"
                    r="4.57291"
                    fill="#33C154"
                    fillOpacity="0.5"
                  />
                  <circle
                    cx="4.57299"
                    cy="106.573"
                    r="3.42968"
                    fill="#33C154"
                  />
                  <path
                    d="M5 11L5 102"
                    stroke="#44585F"
                    strokeWidth="0.228645"
                    strokeDasharray="1.14 1.14"
                  />
                </svg>
              </div>
              <div className={styles.loadFirstA}>
                <div>
                  <p className={styles.city}>
                    {extractAddressComponents(state?.fromCity.name).city},
                    {extractAddressComponents(state?.fromCity.name).state}
                  </p>
                  <div className={styles.loadFirstA1}>
                    <p className={styles.loadFirstA1_address}>
                      {state.fromCity.name}
                    </p>
                    {/* <p className={styles.loadFirstA1_address}>
                    Ashwamegh Warehouse, 4, beside One Center, near Ujala
                    Circle, Sarkhej, Ahmedabad, Gujarat 382210
                  </p> */}
                    <div className={styles.loadFirstA1_time}>
                      <p>06/02/2025</p>
                      <p>|</p>
                      <p>10:30 AM</p>
                    </div>
                  </div>
                </div>
                <div>
                  <p className={styles.city}>
                    {extractAddressComponents(state?.toCity.name).city},{" "}
                    {extractAddressComponents(state?.toCity.name).state}
                  </p>
                  <div className={styles.loadFirstA1}>
                    <p className={styles.loadFirstA1_address}>
                      {state.toCity.name}
                    </p>
                    <div className={styles.loadFirstA1_time}>
                      <p>06/02/2025</p>
                      <p>|</p>
                      <p>10:30 AM</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.loadSecond}>
              <p>535KM</p>
              <svg
                width="171"
                height="15"
                viewBox="0 0 171 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M68 8L1.19209e-06 8"
                  stroke="#44585F"
                  strokeWidth="0.218997"
                  strokeDasharray="1.09 1.09"
                />
                <path
                  d="M171 8L103 8"
                  stroke="#44585F"
                  strokeWidth="0.218997"
                  strokeDasharray="1.09 1.09"
                />
                <path
                  d="M91 6.49712C91 10.7727 85.5 14.4374 85.5 14.4374C85.5 14.4374 80 10.7727 80 6.49712C80 5.03919 80.5795 3.64098 81.6109 2.61007C82.6424 1.57916 84.0413 1 85.5 1C86.9587 1 88.3576 1.57916 89.3891 2.61007C90.4205 3.64098 91 5.03919 91 6.49712Z"
                  stroke="#9CA7AC"
                  strokeWidth="0.796242"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M85.4998 8.32945C86.5124 8.32945 87.3332 7.50907 87.3332 6.49708C87.3332 5.48508 86.5124 4.6647 85.4998 4.6647C84.4873 4.6647 83.6665 5.48508 83.6665 6.49708C83.6665 7.50907 84.4873 8.32945 85.4998 8.32945Z"
                  stroke="#9CA7AC"
                  strokeWidth="0.796242"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <p>48 hours</p>
            </div>
            <div className={`${styles.loadThird} row`}>
              <div className="col-md-6" style={{ padding: "10px 0px" }}>
                <p className={styles.MainText}>6 mt</p>
                <p className={styles.SecondaryText}>Capacity</p>
              </div>
              <div className="col-md-6" style={{ padding: "10px 0px" }}>
                <p className={styles.MainText}>18 Wheels</p>
                <p className={styles.SecondaryText}>Tyre Type</p>
              </div>
              <div className="col-md-6" style={{ padding: "10px 0px" }}>
                <p className={styles.MainText}>Open</p>
                <p className={styles.SecondaryText}>Body Type</p>
              </div>
              <div className="col-md-6" style={{ padding: "10px 0px" }}>
                <p className={styles.MainText}>17 Ft</p>
                <p className={styles.SecondaryText}>Size</p>
              </div>
              <div className="col-md-6" style={{ padding: "10px 0px" }}>
                <p className={styles.MainText}>Auto Parts</p>
                <p className={styles.SecondaryText}>Product Type</p>
              </div>
            </div>
            <div className={styles.loadFour}>
              <p className={styles.MainText}>Remarks*</p>
              <p className={styles.SecondaryText}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industrys standard dummy text
                ever since the 1500s, when an unknown printer took a galley of
                type and scrambled it to make a type specimen book.
              </p>
            </div>
          </div>
        </div>
        <div className={`col-md-8 col-lg-8 col-xs-12`}>
          <div className={styles.load_card_body}>
            <div className={styles.load_card_Table}>
              <table className={styles.load_card_table}>
                <thead className={styles.load_card_table_head}>
                  <tr className={styles.load_card_table_row}>
                    <th>Truck Owner </th>
                    <th style={{ maxWidth: "80px", textAlign: "center" }}>
                      Bid Amount
                    </th>
                    <th>Bid Time</th>
                    <th>Rating</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className={styles.load_card_table_body}>
                  {bid.map((_, i) => (
                    <tr className={styles.load_card_table_body_row} key={i}>
                      <td className="vehicle-no-alerts">FastTrack Logistics</td>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className={
                            i == 0
                              ? styles.lowPrice
                              : i == 1
                              ? styles.mediumPrice
                              : styles.highPrice
                          }
                        >
                          ₹19,000
                        </div>
                      </td>
                      <td>3:45 PM</td>
                      <td className={styles.load_card_table_body_row_rating}>
                        4.3{" "}
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginBottom: "5px" }}
                        >
                          <path
                            d="M7.15375 0.832474C7.28185 0.524489 7.71815 0.524489 7.84625 0.832473L9.39581 4.55808C9.44982 4.68792 9.57192 4.77663 9.71209 4.78787L13.7342 5.11032C14.0667 5.13698 14.2015 5.55192 13.9482 5.76892L10.8838 8.39392C10.777 8.4854 10.7303 8.62895 10.763 8.76573L11.6992 12.6906C11.7766 13.0151 11.4236 13.2715 11.139 13.0977L7.69547 10.9944C7.57546 10.9211 7.42454 10.9211 7.30453 10.9944L3.86104 13.0977C3.57638 13.2715 3.22341 13.0151 3.30081 12.6906L4.23704 8.76573C4.26967 8.62895 4.22303 8.4854 4.11623 8.39392L1.05181 5.76892C0.798483 5.55192 0.933305 5.13698 1.2658 5.11032L5.28791 4.78787C5.42808 4.77663 5.55018 4.68792 5.60419 4.55808L7.15375 0.832474Z"
                            fill="#487283"
                          />
                        </svg>
                      </td>
                      <td>
                        <button
                          className={styles.load_card_table_body_row_button}
                          onClick={() => handleClick(i)}
                        >
                          Accept Bid
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Load;
